import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { propShape, propStr, } from '../../../../../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../../../../../helpers/use/useHook';
import RfpOneDescriptionTabContent from './RfpOneDescriptionTabContent';
import RfpOneDescriptionTabContentModal from './RfpOneDescriptionTabContentModal';
import RfpOneDescriptionTabHead from './RfpOneDescriptionTabHead';
const RfpOneDescriptionTab = (props) => {
    const { mainClass, viewRequest } = props;
    const [tabIndex, changeTabIndex] = useState(1);
    const showProffit = viewRequest.offer.good_point_comment || viewRequest.offer.confirm_comment;
    const items = useMemo(() => [
        { id: 1, label: '提案概要' },
        showProffit ? { id: 2, label: 'Proffitからのコメント' } : null,
    ].filter((v) => v), [showProffit]);
    const { boolState: isShowFullModal, changeFalse: hideFullModal, changeTrue: showFullModal, } = useBoolState();
    const onClickViewMore = useCallback((e) => {
        const { value } = e.currentTarget;
        changeTabIndex(parseInt(value, 10));
        showFullModal();
    }, [changeTabIndex, showFullModal]);
    return (_jsxs("div", Object.assign({ className: 'rfp-description-tab' }, { children: [_jsx(RfpOneDescriptionTabHead, { changeTabIndex: changeTabIndex, items: items, tabIndex: tabIndex }), _jsx(RfpOneDescriptionTabContent, { onClickViewMore: onClickViewMore, tabIndex: tabIndex, viewRequest: viewRequest }, tabIndex), _jsx(RfpOneDescriptionTabContentModal, { changeTabIndex: changeTabIndex, className: mainClass, hideFullModal: hideFullModal, isShow: isShowFullModal, items: items, tabIndex: tabIndex, viewRequest: viewRequest })] })));
};
RfpOneDescriptionTab.propTypes = {
    mainClass: propStr().isRequired,
    viewRequest: propShape().isRequired,
};
export default RfpOneDescriptionTab;
